/* eslint-disable react-hooks/rules-of-hooks */
import { Operator } from '@jexop/core';
import { useMediaQuery, useTheme } from '@mui/material';

type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export const responsiveBreakpoint: Operator<boolean> = ({ direction = 'up', breakpoint = 'xs' }): boolean => {
  const theme = useTheme();
  const validBreakpoints: Breakpoint[] = ['xs', 'sm', 'md', 'lg', 'xl'];
  const bp = validBreakpoints.includes(breakpoint as Breakpoint) ? breakpoint as Breakpoint : 'xs';

  if (direction === 'down') {
    return useMediaQuery(theme.breakpoints.down(bp));
  }
  return useMediaQuery(theme.breakpoints.up(bp));
};
